<template>
    <div style="display: none">
        <slot v-if="ready"></slot>
    </div>
</template>

<script>
import L from "leaflet";
import sortBy from "lodash/sortBy";
import { IRouter, IGeocoder, LineOptions } from "leaflet-routing-machine";
import { findRealParent } from "vue2-leaflet";
import { mapGetters } from "vuex";

const props = {
    visible: {
        type: Boolean,
        default: true,
    },
    waypoints: {
        type: Array,
        required: true,
    },
    router: {
        type: IRouter,
    },
    plan: {
        type: L.Routing.Plan,
    },
    geocoder: {
        type: IGeocoder,
    },
    fitSelectedRoutes: {
        type: [String, Boolean],
        default: "smart",
    },
    lineOptions: {
        type: LineOptions,
    },
    routeLine: {
        type: Function,
    },
    autoRoute: {
        type: Boolean,
        default: true,
    },
    routeWhileDragging: {
        type: Boolean,
        default: false,
    },
    routeDragInterval: {
        type: Number,
        default: 500,
    },
    waypointMode: {
        type: String,
        default: "connect",
    },
    useZoomParameter: {
        type: Boolean,
        default: false,
    },
    showAlternatives: {
        type: Boolean,
        default: false,
    },
    altLineOptions: {
        type: LineOptions,
    },
};

export default {
    props,
    name: "LRoutingMachine",
    data() {
        return {
            parentContainer: null,
            ready: false,
            layer: null,
            customRouter: {},
            api_key: process.env.MIX_OPEN_ROUTE_SERVICE_API_KEY,
        };
    },

    mounted() {
        this.parentContainer = findRealParent(this.$parent);
        this.add();
        this.ready = true;
    },

    beforeDestroy() {
        return this.layer ? this.layer.remove() : null;
    },

    methods: {
        add() {
            let vm = this;
            if (!this.parentContainer._isMounted) {
                return;
            }

            const {
                waypoints,
                fitSelectedRoutes,
                autoRoute,
                routeWhileDragging,
                routeDragInterval,
                waypointMode,
                useZoomParameter,
                showAlternatives,
            } = this;

            const sortedWaypoints = sortBy(waypoints, ['lat']);

            let customRouter = new L.routing.openrouteservice(
                this.api_key,
                {
                    host: "https://directions.hac.hr/ors",
                    profile: "driving-car",
                    instructions: false,
                    routingQueryParams: {
                        preference: "recommended",
                        language: "en",
                        maneuvers: true,
                        options: {
                            avoid_polygons: {
                                type: "Polygon",
                                coordinates: [
                                    [
                                        [
                                            14.08721923828125,
                                            45.35697042434343,
                                        ],
                                        [
                                            14.13116455078125,
                                            45.36131273322709,
                                        ],
                                        [
                                            14.118118286132812,
                                            45.36903157063918,
                                        ],
                                        [
                                            14.083786010742188,
                                            45.36227764550136,
                                        ],
                                        [
                                            14.08721923828125,
                                            45.35697042434343,
                                        ],
                                    ],
                                ],
                            },
                        },
                    },
                }
            );

            let plan = L.Routing.plan(sortedWaypoints, {
                createMarker: function (i, wp) {
                    return L.marker(wp.latLng, {
                        icon: L.icon({
                            iconUrl: "/svg/map/markers/restArea.svg",
                            iconSize: [30.75, 37.5],
                            iconAnchor: [15.375, 37.5],
                        }),
                    });
                },
            });
            const options = {
                sortedWaypoints,
                fitSelectedRoutes,
                autoRoute,
                routeWhileDragging,
                routeDragInterval,
                waypointMode,
                useZoomParameter,
                showAlternatives,
                draggableWaypoints: false,
                lineOptions: {
                    addWaypoints: false,
                    styles: [
                        {
                            color: "#FF2506",
                            weight: 4,
                        },
                    ],
                },
                show: false,
                plan,
                router: customRouter,
            };
            const { mapObject } = this.parentContainer;
            const routingLayer = L.Routing.control(options);

            routingLayer.addTo(mapObject);
            this.layer = routingLayer;
            routingLayer.on("routesfound", function (e) {
                if (vm.tollCoordinates.length) {
                    let routes = e.routes;
                    let res = {
                        distance: customRouter.summary.distance,
                        time: customRouter.summary.duration,
                    };

                    vm.$store.commit("setTollInfo", res);
                }
            });
        },
    },
    computed: {
        ...mapGetters(["tollCoordinates"]),
    },
};
</script>

<style>
@import "~leaflet-routing-machine/dist/leaflet-routing-machine.css";
</style>
